// var autoLoadDuration = 4;
// var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
// var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
// eventList.forEach(function(event) {
//     window.addEventListener(event, triggerScripts, { passive: true })
// });
// function triggerScripts() { 
//     runScripts();
//     clearTimeout(autoLoadTimeout);
//     eventList.forEach(function(event) {
//          window.removeEventListener(event, triggerScripts, { passive: true });
//     });
// }
// function runScripts() {
//     document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
//         scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
//     });
// }


var autoLoadDuration = 4;
var scriptsRun = false;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);

eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true });
});

function triggerScripts() {
    runScripts();
    eventList.forEach(function(event) {
        window.removeEventListener(event, triggerScripts, { passive: true });
    });
}

function runScripts() {
    if (scriptsRun) return;      // guard — prevents double execution
    scriptsRun = true;
    clearTimeout(autoLoadTimeout);

    var scripts = Array.from(document.querySelectorAll("script[delay]"));
    loadSequentially(scripts, 0);
}

function loadSequentially(scripts, i) {
    if (i >= scripts.length) return;
    var tag = scripts[i];
    var next = document.createElement("script");
    next.src = tag.getAttribute("delay");
    next.onload = function() { loadSequentially(scripts, i + 1); };
    next.onerror = function() { loadSequentially(scripts, i + 1); }; // don't stall chain on one failure
    tag.parentNode.replaceChild(next, tag);
}